export default __webpack_public_path__ + "static/media/horsing.5932e7fa.jpg";